import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveOrganisationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  name: Types.Scalars['String']['input'];
  logo?: Types.InputMaybe<Types.Scalars['Upload']['input']>;
}>;


export type SaveOrganisationMutation = { __typename: 'PharosMutations', organisation_Update: { __typename: 'organisationPayload', object: { __typename: 'OrganisationType', id: string, name: string, logo: any | null } | null } | null };


export const SaveOrganisationDocument = gql`
    mutation saveOrganisation($id: ID!, $name: String!, $logo: Upload) {
  organisation_Update(input: {id: $id, name: $name, logo: $logo}) {
    object {
      id
      name
      logo
    }
  }
}
    `;
export type SaveOrganisationMutationFn = Apollo.MutationFunction<SaveOrganisationMutation, SaveOrganisationMutationVariables>;

/**
 * __useSaveOrganisationMutation__
 *
 * To run a mutation, you first call `useSaveOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOrganisationMutation, { data, loading, error }] = useSaveOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useSaveOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<SaveOrganisationMutation, SaveOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOrganisationMutation, SaveOrganisationMutationVariables>(SaveOrganisationDocument, options);
      }
export type SaveOrganisationMutationHookResult = ReturnType<typeof useSaveOrganisationMutation>;
export type SaveOrganisationMutationResult = Apollo.MutationResult<SaveOrganisationMutation>;
export type SaveOrganisationMutationOptions = Apollo.BaseMutationOptions<SaveOrganisationMutation, SaveOrganisationMutationVariables>;